import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Seocompany() {
  return (
    <section className="seo_company p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2>
              An SEO Company that Understands the Challenges Ensures{" "}
              <span>Sustainable Ranking</span>
            </h2>
            <p>
              SEO is not an easy thing to manage, but with a good SEO specialist
              by your side, you are capable of attaining sustainable rankings.
              Our team of experts has seen it all, and we pride ourselves in
              delivering specifically customized solutions that work in the long
              run.
            </p>
            <ul>
              <li>
                Your website lacks the visibility that it should be getting.
              </li>
              <li>
                You have noticed less traffic and you do not know what has gone
                wrong.
              </li>
              <li>
                You have realized that leads and inquiries trail off suddenly.
              </li>
              <li>
                If you are going to launch a new site and expect fast growth.
              </li>
              <li>
                The current SEO strategy that you are implementing cannot yield
                the desired results.
              </li>
            </ul>
            <p>
              If any of these situations are recognizable, you’ve come to the
              right site. We understand that the environment is constantly
              changing, and so, our SEO techniques are tailored to fit into the
              current market needs.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center mt-3 mt-md-0"
          >
            <StaticImage
              src="../../images/services-usa/seo-services/seo-company.webp"
              alt="tekrevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={750}
              height={674}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Seocompany;
